import React from "react";
import { Col, Row } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import ChoiceInput from "../../choiceInput";
import ReactTooltip from "react-tooltip";

interface Props {
  isParentPost: boolean;
  updateIsParentPost: () => void;
  offSet: number;
}

class IsParentSection extends React.PureComponent<Props> {
  static defaultProps = {
    isParentPost: false,
    offSet: 0,
  };

  render() {
    const isParentPost = this.props.isParentPost;
    return (
      <Col
        className={s.content}
        md={{ size: !isParentPost ? 12 : 12, offset: 0 }}
        sm={12}
      >
        <Row>
          <ChoiceInput
            title={"Post to Sub-accounts "}
            checked={this.props.isParentPost}
            onChangeHandler={this.props.updateIsParentPost}
            id={
              "isParentPost" +
              (this.props.isParentPost ? "_checked" : "_unchecked")
            }
            showInfo={true}
            infoId={"PostSubAccountOption"}
          />
          <ReactTooltip
            id={`tpPostSubAccountOption`}
            type="info"
            place="top"
            effect="float"
          >
            Select to create content for sub-accounts.
          </ReactTooltip>
        </Row>
      </Col>
    );
  }
}

export default withStyles(s)(IsParentSection);
